import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {searchPageByIntercept} from '@/api/conversation';
import {sensitiveHitUserInfo} from '@/api/sensitiveHit';
import Content from '@/page/conversation/InterceptConPage/Content';

export default function InterceptConPage({intercept}) {
    useEffect(() => {
        init();
    }, [intercept]);

    const [data, setData] = useState(null);
    const [page, setPage] = useState(null);
    const [receive, setReceive] = useState(null);

    function init() {
        setData(null);
        setReceive(null);
        searchPageByIntercept(intercept.id, 5).then(res => {
            setPage(res.data);
            let postData = {
                roomId: intercept.roomId,
                fromId: intercept.fromId,
                toId: intercept.toId,
            };
            console.log(postData);
            sensitiveHitUserInfo(postData).then(res => {
                console.log(res);
                setData(res.data);
                getReceive(res.data.receiveType, res.data);
            });
        });
    }

    function getReceive(receiveType, value) {
        let receive = null;
        if (receiveType == 1) receive = value.to1;
        if (receiveType == 0) receive = value.to2;
        if (receiveType == 3) receive = value.sysRoom;
        setReceive(receive);
    }

    function renderContent() {
        return (
            <div style={{overflowY: 'auto', height: '80vh', background: '#F8F8F8'}}>
                <Content
                    receiveType={data.receiveType}
                    receive={receive}
                    from={data.from}
                    currentPage={page}
                />
            </div>
        );
    }

    return <div>{data && receive && renderContent()}</div>;
}

InterceptConPage.propTypes = {
    intercept: PropTypes.object,
};
